function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.8 8.39999H4.8C3.8073 8.39999 3 9.20729 3 10.2V19.2C3 20.1927 3.8073 21 4.8 21H13.8C14.7927 21 15.6 20.1927 15.6 19.2V10.2C15.6 9.20729 14.7927 8.39999 13.8 8.39999Z",
  fill: "#6C757D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.2004 3H10.2004C9.723 3 9.26516 3.18964 8.9276 3.52721C8.59003 3.86477 8.40039 4.32261 8.40039 4.8V6.6H15.6004C16.0778 6.6 16.5356 6.78964 16.8732 7.12721C17.2107 7.46477 17.4004 7.92261 17.4004 8.4V15.6H19.2004C19.6778 15.6 20.1356 15.4104 20.4732 15.0728C20.8107 14.7352 21.0004 14.2774 21.0004 13.8V4.8C21.0004 4.32261 20.8107 3.86477 20.4732 3.52721C20.1356 3.18964 19.6778 3 19.2004 3Z",
  fill: "#6C757D"
});

var SvgClone = function SvgClone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clone.6c3aa002.svg";
export { ForwardRef as ReactComponent };